import React from 'react'
import PropTypes from 'prop-types'

import loadable from '@/utils/loadable'
import { ELO } from '@/utils/loadableHelpers'

const Apology = loadable(() => import('@/components/micro/Apology'), ELO)

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true }
	}

	componentDidCatch(error, errorInfo) {
		// Log the error to an error reporting service
		this.logErrorToMyService(error, errorInfo)
	}

	logErrorToMyService(error, errorInfo) {
		console.log(error, errorInfo)
	}

	render() {
		const { hasError } = this.state

		if (hasError) return <Apology />

		return this.props.children
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired, // Define prop types for children
}

export default ErrorBoundary
